import { combineReducers } from "redux";
import counterReducer from "./reducer";

const cardReducer = combineReducers({
  shop: counterReducer,
});

export default cardReducer;
